import { Platform } from 'react-native';

export const sharedGermanLocalization = {
  showMoreButton: {
    showMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen'
  },
  pastTime: {
    justNow: 'gerade',
    yesterday: 'gestern, {{time}}'
  },
  forms: {
    date: {
      hour: 'Uhr',
      cancel: 'Abbrechen'
    }
  },
  location: {
    noLocationService: {
      title: 'Standortdienste deaktiviert',
      content:
        'Die Standortdienste sind auf deinem Gerät deaktiviert. Aktiviere sie in den Systemeinstellungen oder wähle den Ort manuell aus.',
      confirm: 'Alles klar',
      cancel: 'Abbrechen'
    },
    noLocationPermission: {
      title: 'Standortberechtigung deaktiviert',
      content:
        'Der Zugriff auf deinen Standort ist derzeit nicht erlaubt. Du kannst den Ort manuell auswählen oder den Zugriff in den Einstellungen aktivieren.',
      confirm: Platform.select({
        native: 'Einstellungen öffnen',
        default: 'Alles klar'
      }),
      cancel: 'Abbrechen'
    }
  }
};

// Guarantees that both translations have the same structure
type SharedLocalization = typeof sharedGermanLocalization;

export const sharedEnglishLocalization: SharedLocalization = {
  showMoreButton: {
    showMore: 'Show more',
    showLess: 'Show less'
  },
  pastTime: {
    justNow: 'just now',
    yesterday: 'yesterday, {{time}}'
  },
  forms: {
    date: {
      hour: '',
      cancel: 'Cancel'
    }
  },
  location: {
    noLocationService: {
      title: 'Location Services Disabled',
      content:
        'Location services are disabled on your device. Please enable them in system settings or select the location manually.',
      confirm: 'Okay',
      cancel: 'Cancel'
    },
    noLocationPermission: {
      title: 'Location Permission Denied',
      content:
        'Access to your location is currently not allowed. You can select the location manually or enable access in settings.',
      confirm: Platform.select({
        native: 'Open settings',
        default: 'Okay'
      }),
      cancel: 'Cancel'
    }
  }
};
